/* Copyright (c) 2020-present CloudIO Inc */

import { Platform } from '../../platform/Platform';
import { ActionManager, ActionManagerFn } from '../../registry/Component.type';
import { baseActionManager, baseActionProps } from '../../registry/Components';
import { defaultValue } from './ActionLogToConsole';

const ActionLogToConsoleManager: ActionManagerFn<'ActionLogToConsole'> = (
  platform: Platform,
): ActionManager<'ActionLogToConsole'> => {
  return {
    ...baseActionManager(platform, 'ActionLogToConsole'),
    defaultValue,
    props: {
      ...baseActionProps,
    },
    name: 'Log To Console',
    icon: { iconName: 'bug' },
    getDisplayText: () => '',
    description: `**Overview**<br/>
The Log To Console action is a developer utility and debugging tool designed to provide visibility into the application's runtime state. When executed, it outputs the current context—including all available variables, data store states, and previous action results—directly to the browser's developer console.<br/><br/>
This component is essential for "inspecting" the environment during the build process. Unlike user-facing actions, this tool is invisible to the end-user but allows the developer to see exactly what data is available (e.g., inside $._ or $.item) before writing complex expressions or logic.

**Key Features**<br/>
* **Context Inspection:** Automatically dumps the entire current variable scope to the console, revealing hidden objects and data structures available for use in expressions.
* **Zero Configuration:** Requires no setup or properties; it simply logs "everything" available at that specific point in the action chain.

**Use Cases**<br/>
* **Expression Debugging:** Placing this action immediately after an "Invoke Cloud Function" action to inspect the structure of the returned $._.response object before trying to map it to a grid.
* **Loop Logic:** Adding this inside an ActionLoopRecords loop to verify that the iteration variable ($.item or $._.data) contains the expected values for the current row.`,
  };
};

export default ActionLogToConsoleManager;
